module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_location@3x-0973fb16a69b85af34e2ab40c07e4d66.webp";